import BigNumber from 'bignumber.js';
import { DlVault } from 'types/contracts';

export interface GetNetworkRewardRecordsCountInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetNetworkRewardRecordsCountOutput = {
  count: number;
};

const getNetworkRewardRecordsCount = async ({
  dlVaultContract,
  accountAddress,
}: GetNetworkRewardRecordsCountInput): Promise<GetNetworkRewardRecordsCountOutput> => {
  const result = await dlVaultContract.methods
    .getNetworkRewardRecordsCount(accountAddress)
    .call();

  return {
    count: parseInt(result || '0', 10),
  };
};

export default getNetworkRewardRecordsCount; 